//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { SortDirectionEnum } from './enums/sort-direction-enum.enum';
import { API_BASE_URL } from './misc/api-base-url.token';
import { blobToText } from './misc/blob-to-text.function';
import { FileParameter } from './misc/file-parameter.model';
import { FileResponse } from './misc/file-response.model';
import { throwException } from './misc/throw-exception.function';
import { FetchArguments2OfShippingRequestsSearchFilter } from './models/fetch-arguments2of-shipping-requests-search-filter.model';
import { KeyValueDto } from './models/key-value-dto.model';
import { KeyValuePairOfIntegerAndString } from './models/key-value-pair-of-integer-and-string.model';
import { PagingTokenOfComplianceDocumentDto } from './models/paging-token-of-compliance-document-dto.model';
import { PagingTokenOfShippingRequestDto } from './models/paging-token-of-shipping-request-dto.model';
import { RequestBulkStatusUpdateDto } from './models/request-bulk-status-update-dto.model';
import { ShippingRequestAddUpdateDto } from './models/shipping-request-add-update-dto.model';
import { ShippingRequestCandidateDto } from './models/shipping-request-candidate-dto.model';
import { ShippingRequestDetailsDto } from './models/shipping-request-details-dto.model';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ShippingRequestsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    search(filter: FetchArguments2OfShippingRequestsSearchFilter): Observable<PagingTokenOfShippingRequestDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfShippingRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfShippingRequestDto>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PagingTokenOfShippingRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfShippingRequestDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDetails(shippingRequestId: number): Observable<ShippingRequestDetailsDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/{shippingRequestId}";
        if (shippingRequestId === undefined || shippingRequestId === null)
            throw new Error("The parameter 'shippingRequestId' must be defined.");
        url_ = url_.replace("{shippingRequestId}", encodeURIComponent("" + shippingRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingRequestDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingRequestDetailsDto>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<ShippingRequestDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingRequestDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(shippingRequestId: number, dto: ShippingRequestAddUpdateDto): Observable<ShippingRequestDetailsDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/{shippingRequestId}";
        if (shippingRequestId === undefined || shippingRequestId === null)
            throw new Error("The parameter 'shippingRequestId' must be defined.");
        url_ = url_.replace("{shippingRequestId}", encodeURIComponent("" + shippingRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingRequestDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingRequestDetailsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ShippingRequestDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingRequestDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    add(dto: ShippingRequestAddUpdateDto): Observable<ShippingRequestDetailsDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingRequestDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingRequestDetailsDto>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ShippingRequestDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingRequestDetailsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bulkStatusUpdate(dto: RequestBulkStatusUpdateDto): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/bulk-status-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkStatusUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkStatusUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkStatusUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDocuments(shippingRequestId: number, filter_UserId: number | undefined, filter_Name: string | null | undefined, filter_Path: string | null | undefined, filter_UploadedDate: Date | undefined, filter_UploadedBy: string | null | undefined, filter_Title: string | null | undefined, filter_ShippingRequestId: number | null | undefined, filter_HealthRequestId: number | null | undefined, pageSize: number | undefined, skip: number | undefined, sort_Field: string | null | undefined, sort_Type: SortDirectionEnum | undefined, paginated: boolean | undefined): Observable<PagingTokenOfComplianceDocumentDto> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/{shippingRequestId}/documents?";
        if (shippingRequestId === undefined || shippingRequestId === null)
            throw new Error("The parameter 'shippingRequestId' must be defined.");
        url_ = url_.replace("{shippingRequestId}", encodeURIComponent("" + shippingRequestId));
        if (filter_UserId === null)
            throw new Error("The parameter 'filter_UserId' cannot be null.");
        else if (filter_UserId !== undefined)
            url_ += "Filter.UserId=" + encodeURIComponent("" + filter_UserId) + "&";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Path !== undefined && filter_Path !== null)
            url_ += "Filter.Path=" + encodeURIComponent("" + filter_Path) + "&";
        if (filter_UploadedDate === null)
            throw new Error("The parameter 'filter_UploadedDate' cannot be null.");
        else if (filter_UploadedDate !== undefined)
            url_ += "Filter.UploadedDate=" + encodeURIComponent(filter_UploadedDate ? "" + filter_UploadedDate.toISOString() : "") + "&";
        if (filter_UploadedBy !== undefined && filter_UploadedBy !== null)
            url_ += "Filter.UploadedBy=" + encodeURIComponent("" + filter_UploadedBy) + "&";
        if (filter_Title !== undefined && filter_Title !== null)
            url_ += "Filter.Title=" + encodeURIComponent("" + filter_Title) + "&";
        if (filter_ShippingRequestId !== undefined && filter_ShippingRequestId !== null)
            url_ += "Filter.ShippingRequestId=" + encodeURIComponent("" + filter_ShippingRequestId) + "&";
        if (filter_HealthRequestId !== undefined && filter_HealthRequestId !== null)
            url_ += "Filter.HealthRequestId=" + encodeURIComponent("" + filter_HealthRequestId) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (sort_Field !== undefined && sort_Field !== null)
            url_ += "Sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Type === null)
            throw new Error("The parameter 'sort_Type' cannot be null.");
        else if (sort_Type !== undefined)
            url_ += "Sort.Type=" + encodeURIComponent("" + sort_Type) + "&";
        if (paginated === null)
            throw new Error("The parameter 'paginated' cannot be null.");
        else if (paginated !== undefined)
            url_ += "Paginated=" + encodeURIComponent("" + paginated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagingTokenOfComplianceDocumentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagingTokenOfComplianceDocumentDto>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<PagingTokenOfComplianceDocumentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingTokenOfComplianceDocumentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadDocuments(id: number, shippingRequestId: number | null | undefined, healthRequestId: number | null | undefined, vendorId: number | null | undefined, requestId: number | undefined, title: string | null | undefined, file: FileParameter | null | undefined, originalFileName: string | null | undefined, recipeForSuccess: boolean | undefined, path: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/{shippingRequestId}/documents";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{shippingRequestId}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (shippingRequestId !== null && shippingRequestId !== undefined)
            content_.append("ShippingRequestId", shippingRequestId.toString());
        if (healthRequestId !== null && healthRequestId !== undefined)
            content_.append("HealthRequestId", healthRequestId.toString());
        if (vendorId !== null && vendorId !== undefined)
            content_.append("VendorId", vendorId.toString());
        if (requestId === null || requestId === undefined)
            throw new Error("The parameter 'requestId' cannot be null.");
        else
            content_.append("RequestId", requestId.toString());
        if (title !== null && title !== undefined)
            content_.append("Title", title.toString());
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");
        if (originalFileName !== null && originalFileName !== undefined)
            content_.append("OriginalFileName", originalFileName.toString());
        if (recipeForSuccess === null || recipeForSuccess === undefined)
            throw new Error("The parameter 'recipeForSuccess' cannot be null.");
        else
            content_.append("RecipeForSuccess", recipeForSuccess.toString());
        if (path !== null && path !== undefined)
            content_.append("Path", path.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processUploadDocuments(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFile(shippingRequestId: number, documentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/{shippingRequestId}/documents/{documentId}";
        if (shippingRequestId === undefined || shippingRequestId === null)
            throw new Error("The parameter 'shippingRequestId' must be defined.");
        url_ = url_.replace("{shippingRequestId}", encodeURIComponent("" + shippingRequestId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    removeDocument(shippingRequestId: number, documentId: number): Observable<number> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/{shippingRequestId}/documents/{documentId}";
        if (shippingRequestId === undefined || shippingRequestId === null)
            throw new Error("The parameter 'shippingRequestId' must be defined.");
        url_ = url_.replace("{shippingRequestId}", encodeURIComponent("" + shippingRequestId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processRemoveDocument(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchCandidates(name: string | null | undefined): Observable<ShippingRequestCandidateDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/candidates?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCandidates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCandidates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShippingRequestCandidateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShippingRequestCandidateDto[]>;
        }));
    }

    protected processSearchCandidates(response: HttpResponseBase): Observable<ShippingRequestCandidateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingRequestCandidateDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssignees(): Observable<KeyValueDto[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/assignees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValueDto[]>;
        }));
    }

    protected processGetAssignees(response: HttpResponseBase): Observable<KeyValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValueDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reassignTickets(assigneeId: number, requestIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/reassign/{assigneeId}";
        if (assigneeId === undefined || assigneeId === null)
            throw new Error("The parameter 'assigneeId' must be defined.");
        url_ = url_.replace("{assigneeId}", encodeURIComponent("" + assigneeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReassignTickets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReassignTickets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReassignTickets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getChainOfCustodyLookup(): Observable<KeyValuePairOfIntegerAndString[]> {
        let url_ = this.baseUrl + "/ayanova/compliance/shipping-requests/chainOfCustodyLookups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChainOfCustodyLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChainOfCustodyLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<KeyValuePairOfIntegerAndString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<KeyValuePairOfIntegerAndString[]>;
        }));
    }

    protected processGetChainOfCustodyLookup(response: HttpResponseBase): Observable<KeyValuePairOfIntegerAndString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfIntegerAndString[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}